export class CSV {
  constructor() {
    this.rxIsInt = /^\d+$/;
    this.rxIsFloat = /^\d*\.\d+$|^\d+\.\d*$/;
    // If a string has leading or trailing space,
    // contains a comma double quote or a newline
    // it needs to be quoted in CSV output
    this.rxNeedsQuoting = /^\s|\s$|,|"|\n/;
  }
  
  trim(s) {
    // Fx 3.1 has a native trim function,
    // it's about 10x faster, use it if it exists
    if (String.prototype.trim) {
      return s.trim();
    } else {
      return s.replace(/^\s*/, "").replace(/\s*$/, "");
    }
  }
  
  chomp(s, lineterminator) {
    if (s.charAt(s.length - lineterminator.length) !== lineterminator) {
      // Does not end with \n, just return string
      return s;
    } else {
      // Remove the \n
      return s.substring(0, s.length - lineterminator.length);
    }
  }

  normalizeDialectOptions(options) {
    // note lower case compared to CSV DDF
    var out = {
      delimiter: ",",
      doublequote: true,
      lineterminator: "\n",
      quotechar: '"',
      skipinitialspace: true,
      skipinitialrows: 0
    };
    for (var key in options) {
      if (key === "trim") {
        out["skipinitialspace"] = options.trim;
      } else {
        out[key.toLowerCase()] = options[key];
      }
    }
    return out;
  }
  
  processField(options, field, fieldQuoted) {
    let csv = this;
    if (fieldQuoted !== true) {
      // If field is empty set to null
      if (field === "") {
        field = null;
        // If the field was not quoted and we are trimming fields, trim it
      } else if (options.skipinitialspace === true) {
        field = csv.trim(field);
      }
      
      // Convert unquoted numbers to their appropriate types
      if (csv.rxIsInt.test(field)) {
        field = parseInt(field, 10);
      } else if (csv.rxIsFloat.test(field)) {
        field = parseFloat(field, 10);
      }
    }
    return field;
  }
  
  parse(s, dialect) {
    let csv = this;
    // When line terminator is not provided then we try to guess it
    // and normalize it across the file.
    if (!dialect || (dialect && !dialect.lineterminator)) {
      s = csv.normalizeLineTerminator(s, dialect);
    }

    // Get rid of any trailing \n
    var options = csv.normalizeDialectOptions(dialect);
    s = csv.chomp(s, options.lineterminator);

    var cur = "", // The character we are currently processing.
        inQuote = false,
        fieldQuoted = false,
        field = "", // Buffer for building up the current field
        row = [],
        out = [],
        i;
    
    for (i = 0; i < s.length; i += 1) {
      cur = s.charAt(i);
      
      // If we are at a EOF or EOR
      if (
        inQuote === false &&
        (cur === options.delimiter || cur === options.lineterminator)
      ) {
        field = csv.processField(options, field, fieldQuoted);
        // Add the current field to the current row
        row.push(field);
        // If this is EOR append row to output and flush row
        if (cur === options.lineterminator) {
          out.push(row);
          row = [];
        }
        // Flush the field buffer
        field = "";
        fieldQuoted = false;
      } else {
        // If it's not a quotechar, add it to the field buffer
        if (cur !== options.quotechar) {
          field += cur;
        } else {
          if (!inQuote) {
            // We are not in a quote, start a quote
            inQuote = true;
            fieldQuoted = true;
          } else {
            // Next char is quotechar, this is an escaped quotechar
            if (s.charAt(i + 1) === options.quotechar) {
              field += options.quotechar;
              // Skip the next char
              i += 1;
            } else {
              // It's not escaping, so end quote
              inQuote = false;
            }
          }
        }
      }
    }

    // Add the last field
    field = csv.processField(options, field, fieldQuoted);
    row.push(field);
    out.push(row);

    /* Normalize and prune rows */
    let len_cnt = [];
    let max=0, comlen;
    out = out.filter(function(row, idx) {
      if (row.length == 1 && !row[0]) {
        return false;
      }
      return true;
    });
    out.forEach(function(row, idx) {
      if (!len_cnt[row.length]) {
        len_cnt[row.length] = 1;
      } else {
        len_cnt[row.length]++;
      }
    });
    len_cnt.forEach(function(cnt, idx) {
      if (cnt > max) {
        max = cnt;
        comlen = idx;
      }
    });
    if (comlen > 50) { comlen = 50; }
    out.forEach(function(row) {
      while(row.length < comlen) {
        row.push("");
      }
    });

    // Expose the ability to discard initial rows
    //if (options.skipinitialrows) out = out.slice(options.skipinitialrows);

    return {r: out, width: comlen, f:{}};
  }

  classify(c, name, fn) {
    let cnts = [];
    c.r.forEach(function(row) {
      row.forEach(function(v,idx) {
        if (idx >= c.width) { return; }
        if (fn(v)) {
          if (!cnts[idx]) {
            cnts[idx] = 1;
          } else {
            cnts[idx]++;
          }
        }
      });
    });
    let max = 0;
    let match;
    cnts.forEach(function(cnt, idx) {
      if (cnt > max) {
        match = idx;
      }
    });
    if (match !== undefined) {
      c.f[name] = match;
    }
    //console.log(JSON.stringify(c));
    // eslint-disable-next-line
    console.log("csv rows:"+c.r.length+" w:"+c.width+" f:"+JSON.stringify(c.f));
  }
  
  normalizeLineTerminator(csvString, dialect) {
    dialect = dialect || {};

    // Try to guess line terminator if it's not provided.
    if (!dialect.lineterminator) {
      return csvString.replace(/(\r\n|\n|\r)/gm, "\n");
    }
    // if not return the string untouched.
    return csvString;
  }

  objectToArray(dataToSerialize) {
    var a = [];
    var fieldNames = [];
    for (var ii = 0; ii < dataToSerialize.fields.length; ii++) {
      fieldNames.push(dataToSerialize.fields[ii].id);
    }
    a.push(fieldNames);
    for (var ii = 0; ii < dataToSerialize.records.length; ii++) {
      var tmp = [];
      var record = dataToSerialize.records[ii];
      for (var jj = 0; jj < fieldNames.length; jj++) {
        tmp.push(record[fieldNames[jj]]);
      }
      a.push(tmp);
    }
    return a;
  }

  processField2(options, field) {
    let csv = this;
    if (field === null) {
      // If field is null set to empty string
      field = "";
    } else if (typeof field === "string" && csv.rxNeedsQuoting.test(field)) {
      if (options.doublequote) {
        field = field.replace(/"/g, '""');
      }
      // Convert string to delimited string
      field = options.quotechar + field + options.quotechar;
    } else if (typeof field === "number") {
      // Convert number to string
      field = field.toString(10);
    }
    
    return field;
  }

  serialize(dataToSerialize, dialect) {
    let csv = this;
    var a = null;
    if (dataToSerialize instanceof Array) {
      a = dataToSerialize;
    } else {
      a = csv.objectToArray(dataToSerialize);
    }
    var options = csv.normalizeDialectOptions(dialect);

    var cur = "", // The character we are currently processing.
      field = "", // Buffer for building up the current field
      row = "",
      out = "",
      i,
      j;

    for (i = 0; i < a.length; i += 1) {
      cur = a[i];

      for (j = 0; j < cur.length; j += 1) {
        field = csv.processField2(options, cur[j]);
        // If this is EOR append row to output and flush row
        if (j === cur.length - 1) {
          row += field;
          out += row + options.lineterminator;
          row = "";
        } else {
          // Add the current field to the current row
          row += field + options.delimiter;
        }
        // Flush the field buffer
        field = "";
      }
    }

    return out;
  }
}
